import { computed, ref } from 'vue'

// Глобальные переменные (вне функции), чтобы состояние было единым
const installPrompt = ref<any>(null)
const isAppInstalled = ref(false)

// Инициализация слушателей сразу при импорте файла
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault()
    installPrompt.value = e
    isAppInstalled.value = false
  })

  window.addEventListener('appinstalled', () => {
    installPrompt.value = null
    isAppInstalled.value = true
  })
}

export const usePwa = () => {
  const canInstall = computed(() => !!installPrompt.value)

  const triggerInstall = async () => {
    if (!installPrompt.value) return
    installPrompt.value.prompt()
    const { outcome } = await installPrompt.value.userChoice
    if (outcome === 'accepted') {
      installPrompt.value = null
    }
  }

  // 👇 Добавлена функция открытия
  const openPwa = () => {
    window.location.href = 'web+daomed://open'
  }

  return { installPrompt, canInstall, triggerInstall, openPwa }
}
